// @flow
import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {apiClient} from '../../../../../shared/api';
import {GET_PUSH_SERVICE_INFO, GET_UNREAD_NOTIFICATION, READ_NOTIFICATION} from './constants';
import {
    getPushServiceInfoFailed,
    getPushServiceInfoSuccess,
    getUnreadNotification as getUnreadNotificationAction,
    getUnreadNotificationFailed,
    getUnreadNotificationSuccess,
    readNotificationFailed,
    readNotificationSuccess,
} from './actions';

function* getPushServiceInfo() {
    const options = {
        method: 'get'
    };
    const response = yield call(apiClient.request, 'api/v2/notification/push-service', options);

    if (response.error) {
        yield put(getPushServiceInfoFailed(response.detail));
    } else {
        yield put(getPushServiceInfoSuccess(response));

        yield put(getUnreadNotificationAction())
    }
}

function* getUnreadNotification() {
    const response = yield call(apiClient.list, 'api/v2/notification');

    if (response.error) {
        yield put(getUnreadNotificationFailed(response.detail));
    } else {
        yield put(getUnreadNotificationSuccess(response.data));
    }
}

function* readNotification({payload}) {
    if (!Array.isArray(payload)) {
        payload = [payload]
    }
    const options = {
        method: 'put',
        body: payload
    };
    const response = yield call(apiClient.request, 'api/v2/notification', options);

    if (response.error) {
        yield put(readNotificationFailed(response.detail));
    } else {
        yield put(readNotificationSuccess(response.data));

        yield put(getUnreadNotificationAction())
    }
}

export function* watchGetPushServiceInfo(): any {
    yield takeEvery(GET_PUSH_SERVICE_INFO, getPushServiceInfo);
}

export function* watchGetUnreadNotification(): any {
    yield takeEvery(GET_UNREAD_NOTIFICATION, getUnreadNotification);
}

export function* watchReadNotification(): any {
    yield takeEvery(READ_NOTIFICATION, readNotification);
}

function* NotificationSaga(): any {
    yield all([
        fork(watchGetPushServiceInfo),
        fork(watchGetUnreadNotification),
        fork(watchReadNotification)
    ]);
}

export default NotificationSaga;
